// extracted by mini-css-extract-plugin
module.exports =  {"cardContainer":"AboutSectionSmallCard-module_cardContainer_aa853","close":"AboutSectionSmallCard-module_close_c9510"};